import React from 'react';
var defaults = {
  jobId: undefined,
  jobPageCanonicalUrl: undefined,
  shouldPubSub: undefined,
  i18n: undefined,
  isMobile: undefined,
  title: undefined,
  forceSmall: undefined,
  employer: undefined,
  shortDescription: undefined,
  displayLocation: undefined,
  quickApplication: undefined,
  promoId: '',
  cardStyle: undefined,
  displayJobStartDate: undefined,
  flag: {},
  application: undefined,
  extraClasses: undefined,
  customCta: undefined,
  modulesV2: undefined,
  target: undefined,
  forceLogo: undefined,
  isNurtured: undefined,
  logoWidth: undefined,
  logoHeight: undefined,
  useLogoPlaceholder: undefined,
  forceJobShortDescription: false,
  forceSalaryDescription: false
};
export var JobContext = /*#__PURE__*/React.createContext(defaults);